import * as ActionTypes from './actionTypes';

export const getInvoices = (payload) => ({
  type: ActionTypes.GET_INVOICES,
  payload,
});

export const getInvoicesSuccess = (payload) => ({
  type: ActionTypes.GET_INVOICES_SUCCESS,
  payload,
});

export const getInvoicesFailed = () => ({
  type: ActionTypes.GET_INVOICES_FAILED,
});

export const getGlobalInvoices = (payload) => ({
  type: ActionTypes.GET_GLOBAL_INVOICES,
  payload,
});

export const getGlobalInvoicesSuccess = (payload) => ({
  type: ActionTypes.GET_GLOBAL_INVOICES_SUCCESS,
  payload,
});

export const getGlobalInvoicesFailed = () => ({
  type: ActionTypes.GET_GLOBAL_INVOICES_FAILED,
});

export const getGlobalInvoiceDetail = (payload) => ({
  type: ActionTypes.GET_GLOBAL_INVOICE_DETAIL,
  payload,
});

export const getGlobalInvoiceDetailSuccess = (payload) => ({
  type: ActionTypes.GET_GLOBAL_INVOICE_DETAIL_SUCCESS,
  payload,
});

export const getGlobalInvoiceDetailFailed = () => ({
  type: ActionTypes.GET_GLOBAL_INVOICE_DETAIL_FAILED,
});

export const cleanupGlobalInvoiceDetail = () => ({
  type: ActionTypes.CLEANUP_GLOBAL_INVOICE_DETAIL,
});

export const getInvoiceDetail = (payload) => ({
  type: ActionTypes.GET_INVOICE_DETAIL,
  payload,
});

export const getInvoiceDetailSuccess = (payload) => ({
  type: ActionTypes.GET_INVOICE_DETAIL_SUCCESS,
  payload,
});

export const getInvoiceDetailFailed = () => ({
  type: ActionTypes.GET_INVOICE_DETAIL_FAILED,
});

export const payInvoice = (payload) => ({
  type: ActionTypes.PAY_INVOICE,
  payload,
});

export const payInvoiceSuccess = (payload) => ({
  type: ActionTypes.PAY_INVOICE_SUCCESS,
  payload,
});

export const payInvoiceFailed = () => ({
  type: ActionTypes.PAY_INVOICE_FAILED,
});

export const exportInvoice = (payload) => ({
  type: ActionTypes.EXPORT_INVOICE,
  payload,
});

export const exportInvoiceSuccess = (payload) => ({
  type: ActionTypes.EXPORT_INVOICE_SUCCESS,
  payload,
});

export const exportInvoiceFailed = () => ({
  type: ActionTypes.EXPORT_INVOICE_FAILED,
});
